import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMasterCodeControl extends Layout {
    panelContent: Panel;
    sourceAutogen: DataSource;
    switchAllowManualEntry: Switch;
    switchIsActive: Switch;
    textboxDupHandling: Textbox;
    textboxMask: Textbox;
    textboxMinChars: Textbox;
    textboxStartAt: Textbox;
    textboxTableName: Textbox;
}
